<!--
  The two cards subgrid a shared 3-row track (title / subtitle / chart) from this parent grid, so
  a longer or wrapped subtitle on one card pushes both cards' chart row down by the same amount -
  keeping the two charts vertically aligned instead of drifting apart based on each card's own
  subtitle length.
-->
<div class="grid grid-cols-1 xl:grid-cols-2 xl:grid-rows-[auto_auto_auto] gap-4">
  <div
    class="rounded-2xl border border-shikenso-purple-base-12 bg-shikenso-base-white p-4 xl:row-span-3 xl:grid xl:grid-rows-[subgrid]"
  >
    <h4 class="text-base font-medium">{{ 'pages.admin.eventAnalytics.overview.journeyChart.title' | translate }}</h4>
    <p class="text-xs text-shikenso-purple-base-60 mt-1 mb-2">
      {{ 'pages.admin.eventAnalytics.overview.journeyChart.subtitle' | translate }}
    </p>

    <app-bar-graph [options]="journeyChartOptions()" [loading]="loading()" />
  </div>

  <div
    class="rounded-2xl border border-shikenso-purple-base-12 bg-shikenso-base-white p-4 xl:row-span-3 xl:grid xl:grid-rows-[subgrid]"
  >
    <h4 class="text-base font-medium">{{ 'pages.admin.eventAnalytics.overview.timeChart.title' | translate }}</h4>

    <!-- No subtitle for this chart - an empty cell still participates in the subgrid's shared
         subtitle row, so it grows to match the journey chart's subtitle height automatically. -->
    <div class="mt-1 mb-2"></div>

    <app-bar-graph [options]="timeOnTaskChartOptions()" [loading]="loading()" />
  </div>
</div>
